export default __webpack_public_path__ + "static/media/job_offer2_l.7e989fea.jpg";